<template>
  <div class="inspection-detail">
    <vue-headful :title="`Inspection - ${inspectionStreetAddress}`" />

    <template v-if="loaded">
      <div class="inspection-detail--header">
        <InspectionDetailHeader :folderId="folderId" />
      </div>

      <div class="inspection-detail--content">
        <div class="central">
          <Alert
            v-if="forwardComplete"
            type="info"
            id="confirmation-callout"
            @close="forwardComplete = false">
            {{confirmationMessage}}
          </Alert>

          <InspectionDetailHero
            :agreementsSuccess="showAgreementsSuccess"
            :agreementsWarning="showAgreementsWarning"
            :folderId="folderId"
            @closeSuccess="resetShowAgreementsSuccess"
            @closeWarning="resetShowAgreementsWarning"
            @copy="copy"/>
        </div>

        <InspectionDetailPromos />

        <InspectionDetailContent :folderId="folderId" />
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import Alert from '@/components/Shared/Alert.vue';
import InspectionDetailContent from './InspectionDetailContent.vue';
import InspectionDetailHeader from './InspectionDetailHeader.vue';
import InspectionDetailHero from './InspectionDetailHero.vue';
import InspectionDetailPromos from './InspectionDetailPromos.vue';

export default {
  name: 'hgInspection',
  components: {
    Alert,
    InspectionDetailContent,
    InspectionDetailHeader,
    InspectionDetailHero,
    InspectionDetailPromos,
  },
  data() {
    return {
      showAgreementsSuccess: this.hgShowAgreementsSuccess,
      showAgreementsWarning: this.hgShowAgreementsWarning,
      forwardComplete: this.hgForwardComplete,
    };
  },
  props: {
    forwardedRecipients: {
      type: Array,
      default: () => [],
    },
    hgForwardComplete: {
      type: Boolean,
      required: true,
    },
    folderId: {
      type: String,
      required: true,
    },
    hgShowAgreementsSuccess: {
      type: Boolean,
      default: false,
    },
    hgShowAgreementsWarning: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      loaded: state => state.loaded,
    }),
    ...mapState('Inspection', {
      inspection: state => state.inspection,
    }),
    ...mapGetters('Inspection', ['inspectionStreetAddress']),
    confirmationMessage() {
      let message = 'Document Forwarded';
      if (this.forwardedRecipients.length > 0) {
        message += ` to ${this.forwardedRecipients.join(', ')}`;
      }
      return message;
    },
  },
  methods: {
    copy(crlId) {
      const $this = this;
      const { folderId } = $this;
      $this.$store
        .dispatch('HgClassic/copyCrl', { crlId })
        .then(() => $this.$store.dispatch('Inspection/loadInspection', folderId));
    },
    resetShowAgreementsSuccess() {
      this.showAgreementsSuccess = false;
    },
    resetShowAgreementsWarning() {
      this.showAgreementsWarning = false;
    },
    // saveThirdParty(data) {
    //   const $this = this;
    //   $this.$store
    //     .dispatch('HgClassic/saveCustomerThirdPartyAcceptance', data)
    //     .then(() => $this.$store.dispatch('HgClassic/loadCustomerThirdParty', data));
    // },
  },
};
</script>

<style lang="scss" scoped>
.inspection-detail {
  &--header,
  &--content {
    position: relative;
  }

  &--header {
    z-index: 1;
  }

  &--content {
    z-index: 2;
  }
}

.central {
  margin: 0 auto;
  min-height: 370px;
  padding-top: 30px;
  position: relative;
  width: 90%;
}

@media all and (max-width: 655px) {
  .central {
    min-height: 0;
    top: 0;
    width: 100%;
  }
}
</style>
